import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_TYPE_PREFIX_URL = '/document-type'
export const URL_ENDPOINT_DOCUMENT_TYPE = `${BASE_URL}/document-type`
